import React from 'react';

const SlotRight = () => {
    return (
        <div data-v-623d66c4="" className="right-drawer scrollable-auto column">
            <div data-v-2fe6782b="" data-v-623d66c4="" className="right-out column">
                <div data-v-2fe6782b="" className="column" style={{flexShrink: "0", flexGrow: "1"}}>
                    <div data-v-2fe6782b="" className="row" style={{flexDirection: "row", flexShrink: "0"}}>
                        <a data-v-2fe6782b="" href="" target="_blank">
                            <img data-v-2fe6782b="" src="../images/CasinoRight/mark.png" alt=""/>
                        </a>
                    </div>
                    <div data-v-734bc4a5="" data-v-2fe6782b="" className="promopage tabs tabs-lg" style={{flexGrow: "1"}}>
                        <div data-v-734bc4a5="" className="tabs-header">
                            <div data-v-734bc4a5="" className="tabs-header-item tabs-header-item-active tabs-header-item-fill" style={{flexBasis: "0px"}}>
                                이벤트
                    </div>
                        </div>
                        <div data-v-734bc4a5="" className="tabs-content">
                            <div data-v-73382a62="" data-v-2fe6782b="" className="active" data-v-734bc4a5="" >
                                <div data-v-b5a26816="" data-v-2fe6782b="" className="promo-list column" data-v-73382a62="">
                                    {/* <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" href="" className="button text" style={{background: "transparent"}}>
                                            <img data-v-b5a26816="" src="../images/CasinoRight/다폴더.png" alt="다폴더 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" href="" className="button text" style={{background: "transparent"}}>
                                            <img data-v-b5a26816="" src="../images/CasinoRight/낙첨.png" alt="낙첨금 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" href="" className="button text" style={{background: "transparent"}}>
                                            <img data-v-b5a26816="" src="../images/CasinoRight/올낙첨.png" alt="올낙첨 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" href="" className="button text" style={{background: "transparent"}}>
                                            <img data-v-b5a26816="" src="../images/CasinoRight/첫가입.png" alt="첫가입 첫충전 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" href="" className="button text" style={{background: "transparent"}}>
                                            <img data-v-b5a26816="" src="../images/CasinoRight/매일.png" alt="매일 옵션 이벤트 25%" />
                                        </a>
                                    </div>
                                    <a data-v-b5a26816="" href="" className="more-btn button">
                                        <span data-v-b5a26816="" className="text" style={{height: "auto"}}>더보기</span>
                                    </a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SlotRight;


// WEBPACK FOOTER //
// ./src/components/Slot/SlotRight.js